module.exports = __webpack_public_path__ + "static/media/cdfw.206ba767.webp";